module.exports = __webpack_public_path__ + "img/rand_money.3b4c8103.svg";